import { SYSTEM_EVENTS } from "../../events/events";
import Event from '../../utils/event';
import BaseComponent from "../../base/base_component";
import { PRIORITY_LEVEL } from "../../services/overlay_manager/overlay_manager_levels";


const VIEW = require('./view/blue_ribbon_welcome_popup.html');
const footerView = require('./view/blue_ribbon_welcome_popup_footer.html');

export default class BlueRibbonJackpotWelcomeComponent extends BaseComponent {
    init(params) {
        super.init(params);
        this._bakeContent();
        this._subscribe();
    }

    _subscribe() {
        this.onceSystemEvent(SYSTEM_EVENTS.GAME_OPEN, () => {
            this.closePopup();
        });

        this.onceSystemEvent(SYSTEM_EVENTS.CLOSE_ALL_OVERLAY, () => {
            this.closePopup();
        });
    }

    _bakeContent() {
        const content = this.bake(VIEW, {});
        this.setHTML(content);
    }

    showPopup() {
        const footerText = this.bake(footerView, {});

        this.serviceFactory.messageManagerService().openMessage({
            text: this.getEl(),
            hasTitle: false,
            buttonPosition: 'center',
            customCSSClassList: ['cgp-blue-ribbon-welcome-component'],
            footerText: footerText,
            buttons: [{
                name: this.serviceFactory.languageService().translation('br_welcome_continue_btn'),
                isClosable: true,
                callback: () => { 
                    this._onContinue();
                }
            }],
            openCallback: () => {
                this._onOpened();
            },
            footerClickedCallback: () =>{
                this._onReadMore();
                this.closePopup();
            },
            priority: PRIORITY_LEVEL.POP_UP
        });
    
        return this;
    }

    closePopup() {
        Event.fire(SYSTEM_EVENTS.CLOSE_OVERLAY, {priority: PRIORITY_LEVEL.POP_UP});
    }

    _onOpened() {
        this._sendAnalytics({label: 'blue_ribbon_join_view'});
    }

    _onContinue() {
        this._sendAnalytics({label: 'blue_ribbon_join_click'});
    }

    _onReadMore() {
        this._sendAnalytics({label: 'blue_ribbon_join_read_more'});
        this.serviceFactory.blueRibbonService().showPersonalJackpotPromotionPage();
    }

    _sendAnalytics(analyticsData: {label: string}): void{
        const analyticsObject = {
            category: 'Personal_Jackpot',
            action: 'Intro_Message',
            label: analyticsData.label
        };

        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, Object.assign(analyticsObject, analyticsData));
    }
}
